import React, { useState, useEffect, useCallback, useContext } from "react";
import { Link } from "react-router-dom";
import AddcaseModal from "./modals/add_case";
import { AuthContext } from "../../../../Context/AuthContext";
import AssigncaseModal from "./modals/assign_case";
import EditAssigncaseModal from "./modals/edit_assign_case";
import { ApiService } from "../../../../services/ApiService";
import { useAlert } from "react-alert";
import { ConfirmTemplate } from "../../../../components/confirm";
import Modal from "react-modal";
import useModal from "../../../../utils/useModal";
import { employeeMngtThunk } from "../../../../store/actions/employeemanagement/employee.thunk";
import { useDispatch, useSelector } from "react-redux";
import { PageBody } from "../../../../components/loader";
import { useLoadingMessage } from "../../../../components/useLoadingMessage";
import { capitalize } from "../../../../utils/capitalize";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "50%",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    // border: "2px solid green",
  },
};

Modal.setAppElement("#root");

export const EmployeeDeciplinaryCase = () => {
  const { user } = useContext(AuthContext);
  const alert = useAlert();
  const [editassigncase, setEditassigncase] = useState(false);
  // const [cases, setCases] = useState([]);
  // const [employees, setEmployees] = useState([]);
  const [casevalue, setCasevalue] = useState([]);
  const [loader, setLoader] = useState(false);
  const [searchCases, setSearchCases] = useState("");
  const { isLoading, message, updateLoader } = useLoadingMessage();

  const { disciplinaryCases, employees, cases } = useSelector(
    (state) => state.employeeMngt
  );
  const dispatch = useDispatch();
  // const { modalIsOpen, openModal, closeModal } = useModal();

  // const { casess, } = useSelector((state) => state.employeeMngt);

  const [newCasemodalIsOpen, setnewCasemodalIsOpen] = useState(false);
  const [assignCasemodalIsOpen, setAssignCasemodalIsOpen] = useState(false);
  const [editCasemodalIsOpen, setEditCasemodalIsOpen] = useState(false);

  const openNewCaseModal = () => {
    setnewCasemodalIsOpen(true);
  };

  const openEditCaseModal = () => {
    setEditCasemodalIsOpen(true);
  };

  const openAssignCaseModal = () => {
    setAssignCasemodalIsOpen(true);
  };

  const closeModal = () => {
    setnewCasemodalIsOpen(false);
    setAssignCasemodalIsOpen(false);
    setEditCasemodalIsOpen(false);
  };

  //   const togglecase = () => {
  //     setAssigncase(!assigncase);
  //   };
  const edittogglecase = () => {
    setEditassigncase(!editassigncase);
  };

  const closeCase = (id) => {
    const request = async () => {
      const case_id = {
        case_id: id,
      };
      const res = await ApiService.post(
        "disciplinary-cases/close-case",
        case_id
      );
      if (res.data.type === false) {
        alert.error(res.data.msg);
      } else if (res.data.type === true) {
        alert.success(res.data.msg);
        getDiciplinaryCase();
      }
    };
    ConfirmTemplate(
      {
        title: "Close Case",
        message: "Are You Sure You Want To Close This Case",
      },
      request
    );
  };

  const openCase = (id) => {
    const request = async () => {
      const case_id = {
        case_id: id,
      };
      const _method = {
        _method: "patch",
      };
      const res = await ApiService.post(
        "disciplinary-cases/open-case",
        case_id,
        _method
      );
      if (res.data.type === false) {
        alert.error(res.data.msg);
      } else if (res.data.type === true) {
        alert.success(res.data.msg);
        getDiciplinaryCase();
      }
    };
    ConfirmTemplate(
      {
        title: "Open Case",
        message: "Are You Sure You Want To Open This Case",
      },
      request
    );
  };

  // console.log("casesss", disciplinaryCases);

  const getDiciplinaryCase = useCallback(async () => {
    updateLoader(true, "Getting all disciplinary cases");
    await dispatch(employeeMngtThunk.getDiciplinaryCases());
    await dispatch(employeeMngtThunk.getEmployeesDetails());
    await dispatch(employeeMngtThunk.getAllCases());
    updateLoader(false);
  }, [dispatch]);

  useEffect(() => {
    getDiciplinaryCase();
  }, []);

  const AllCase = disciplinaryCases.filter((cases) => {
    return (
      cases &&
      cases.disciplinary_id.name
        .toLowerCase()
        .indexOf(searchCases.toLowerCase()) !== -1
    );
  });

  return (
    <React.Fragment>
      <PageBody isLoading={isLoading} message={message}>
        <Modal
          isOpen={newCasemodalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="add cases modal"
        >
          <AddcaseModal
            closeModal={closeModal}
            alert={alert}
            employee_cases={getDiciplinaryCase}
          />
        </Modal>
        <Modal
          isOpen={assignCasemodalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="assign cases modal"
        >
          <AssigncaseModal
            closeModal={closeModal}
            alert={alert}
            employee_cases={getDiciplinaryCase}
            employees={employees}
            cases={cases}
          />
        </Modal>
        <Modal
          isOpen={editCasemodalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="assign cases modal"
        >
          <EditAssigncaseModal
            closeModal={closeModal}
            employees={employees}
            cases={cases}
            employee_cases={getDiciplinaryCase}
            alert={alert}
            value={casevalue}
          />
        </Modal>
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box-two">
                  <h4 className="page-title"></h4>
                  <h1 className="welcome_text">EMPLOYEE MANAGEMENT</h1>
                  <div className="clearfix"></div>
                </div>
              </div>
            </div>

            <div>
              <nav
                className="navbar navbar-light navbar-expand-md bg-faded justify-content-center"
                style={{
                  boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.075)",
                }}
              >
                <a href="/" className="navbar-brand d-flex w-50 mr-auto"></a>
                <ul className="navbar-nav w-100 ml-auto justify-content-center">
                  <li className="nav-item ml-auto">
                    <Link
                      className="nav-link"
                      to="/dashboard/employee"
                      style={{
                        borderRight: "3px solid #243050",
                      }}
                    >
                      EMPLOYEE
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to="/dashboard/employee/disciplinary"
                      style={{
                        borderRight: "3px solid #243050",
                      }}
                    >
                      DISCIPLINARY CASE{" "}
                      {/* <button onClick={openModal}>Moadal</button> */}
                    </Link>
                  </li>
                </ul>
                <div
                  className="navbar-collapse collapse w-100"
                  id="collapsingNavbar3"
                >
                  <ul className="nav navbar-nav ml-auto w-100 justify-content-end">
                    <li className="nav-item ml-auto"></li>
                  </ul>
                </div>
              </nav>
            </div>

            <div className="row">
              <div className="col-lg-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    <div className="card-title">
                      <div className="table-title">
                        <div className="row">
                          <div className="col-sm-6">
                            <h2>
                              <b>DISCIPLINARY</b> CASE
                            </h2>
                          </div>
                          {(user.data.user.roles &&
                            user.data.user.roles.name === "admin") ||
                          user.data.user.roles.name === "human resource" ||
                          user.data.user.roles.name === "line manager" ? (
                            <div className="col-sm-6">
                              <button
                                className="btn nt-button-color-action trigger-btn"
                                onClick={openNewCaseModal}
                              >
                                <i className="material-icons">&#xE147;</i>{" "}
                                <span>ADD NEW CASE</span>
                              </button>
                              <button
                                id="assign_case"
                                className="btn nt-button-color-action"
                                data-toggle="modal"
                                onClick={openAssignCaseModal}
                              >
                                <i className="material-icons">&#xE15C;</i>{" "}
                                <span>ASSIGN CASE</span>
                              </button>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div className="mb-3 clearfix">
                      <div
                        class="btn-group float-left"
                        role="group"
                        aria-label="Basic example"
                      >
                        <button
                          type="button"
                          class="btn btn-secondary btn-group-sm"
                          onClick={() => window.print()}
                        >
                          Print
                        </button>
                        <ReactHTMLTableToExcel
                          id="test-table-xls-button"
                          className="btn btn-secondary btn-group-sm"
                          table="case-table"
                          filename="DISCIPLINARY CASE"
                          sheet="tablexls"
                          buttonText="Export to excel"
                        />
                      </div>

                      <form class="form-inline my-2 my-lg-0 float-right">
                        <input
                          class="form-control mr-sm-2"
                          type="search"
                          placeholder="Search"
                          aria-label="Search"
                          name="search"
                          value={searchCases}
                          onChange={(e) => setSearchCases(e.target.value)}
                        />
                      </form>
                    </div>

                    <div className="table-responsive">
                      {/* <p> No disciplinary case </p> */}

                      <table
                        // id="disciplinary_table"
                        id="case-table"
                        className="table table-bordered asset-table table-disciplinary-case dtMaterialDesignExample"
                      >
                        <thead>
                          <tr>
                            <th>NO</th>
                            <th className="th-sm">ASSIGNED TO</th>
                            <th className="th-sm">ASSIGNED BY</th>
                            <th className="th-sm">CASE</th>
                            <th className="th-sm">PENALTY</th>
                            <th className="th-sm">STATUS</th>
                            {(user.data.user.roles &&
                              user.data.user.roles.name === "admin") ||
                            user.data.user.roles.name === "human resource" ? (
                              <th className="notexport"></th>
                            ) : null}
                          </tr>
                        </thead>
                        <tbody>
                          {AllCase.map((cases, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>
                                {capitalize(cases.assigned_to.first_name)}
                              </td>
                              <td>
                                {capitalize(cases.assigned_by.first_name)}
                              </td>
                              <td>{capitalize(cases.disciplinary_id.name)}</td>
                              <td>{cases.penalty}</td>

                              <td>
                                {cases.status === 1 ? (
                                  <div>
                                    <span className="status text-success">
                                      &bull;
                                    </span>
                                    Opened
                                  </div>
                                ) : (
                                  <div>
                                    <span className="status text-danger">
                                      &bull;
                                    </span>{" "}
                                    Closed
                                  </div>
                                )}
                              </td>

                              {/* <td><span className="status text-failure">&bull;</span> Closed</td> */}
                              {(user.data.user.roles &&
                                user.data.user.roles.name === "admin") ||
                              user.data.user.roles.name === "human resource" ? (
                                <td>
                                  <div className="dropdown pull-right">
                                    <a
                                      href="#"
                                      className="dropdown-toggle card-drop arrow-none"
                                      data-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <h3 className="m-0 text-muted">
                                        <i className="fa fa-ellipsis-v"></i>
                                      </h3>
                                    </a>
                                    <div
                                      className="dropdown-menu dropdown-menu-right"
                                      aria-labelledby="btnGroupDrop1"
                                    >
                                      <button
                                        className="dropdown-item"
                                        onClick={() => {
                                          const value = {
                                            id: cases.id,
                                            assigned_to: cases.assigned_to.id,
                                            assigned_by: cases.assigned_by.id,
                                            case: cases.disciplinary_id.id,
                                            penalty: cases.penalty,
                                          };
                                          setCasevalue(value);
                                          openEditCaseModal();
                                        }}
                                        id="show_edit_assign_disciplinary_case_btn"
                                      >
                                        Edit
                                      </button>
                                      {cases.status === 1 ? (
                                        <button
                                          className="dropdown-item"
                                          onClick={() => {
                                            closeCase(cases.id);
                                          }}
                                          id="close_case_btn"
                                        >
                                          Close
                                        </button>
                                      ) : (
                                        <button
                                          className="dropdown-item"
                                          onClick={() => {
                                            openCase(cases.id);
                                          }}
                                          id="open_case_btn"
                                        >
                                          Open
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </td>
                              ) : null}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageBody>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/employeemanagement/disciplinarycase/index.js